module.exports = __webpack_public_path__ + "img/introduction-img@560w.9f8ada60.png";